import React from 'react';
import { Button } from './ui/button';
import { Play, Info } from 'lucide-react';
import { heroData } from '../mock';

const Hero = () => {
  return (
    <section id="inicio" className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={heroData.backgroundImage}
          alt="Hero Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-transparent to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-6 md:space-y-8">
          {/* Title with Animation */}
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-white leading-tight animate-fade-in">
            <span className="text-red-600">Apex</span> Stream
          </h1>

          {/* Subtitle */}
          <p className="text-lg sm:text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto font-medium">
            {heroData.subtitle}
          </p>

          {/* Features Tags */}
          <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-sm md:text-base">
            <span className="bg-red-600/20 border border-red-600 text-red-500 px-4 py-2 rounded-full font-semibold backdrop-blur-sm">
              🔴 AO VIVO
            </span>
            <span className="bg-white/10 border border-white/30 text-white px-4 py-2 rounded-full font-semibold backdrop-blur-sm">
              HD/4K
            </span>
            <span className="bg-white/10 border border-white/30 text-white px-4 py-2 rounded-full font-semibold backdrop-blur-sm">
              Multi-Dispositivos
            </span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <a
              href="https://linkly.link/2WYOm"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-red-600 hover:bg-red-700 text-white font-bold text-lg px-10 py-6 rounded-lg shadow-2xl hover:shadow-red-600/50 transition-all hover:scale-105 flex items-center gap-2 w-full sm:w-auto justify-center"
            >
              <Play className="w-6 h-6 fill-white" />
              {heroData.ctaText}
            </a>
            <a
              href="https://linkly.link/2WYOm"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white hover:bg-white hover:text-black font-bold text-lg px-10 py-6 rounded-lg transition-all hover:scale-105 flex items-center gap-2 w-full sm:w-auto bg-transparent justify-center"
            >
              <Info className="w-6 h-6" />
              Saiba Mais
            </a>
          </div>

          {/* Scroll Indicator */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
            <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
              <div className="w-1 h-3 bg-white/70 rounded-full"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
